export default __webpack_public_path__ + "static/media/analyze_edit_your_videos.1a1e4db8.gif";